//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_components/index";
import { WithPermissionCheck } from "../../../../components/common/WithPermissionCheck";

export default function ResourceQuestionForm() {
  return (
    <WithPermissionCheck>
      <div className="row">
        <Suspense>
          <Content />
        </Suspense>
      </div>
    </WithPermissionCheck>
  );
}
